export const UPLOAD_REQUEST = 'UPLOAD_REQUEST'
export const UPLOAD_STARTED = 'UPLOAD_STARTED'
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
export const UPLOAD_FAILURE = 'UPLOAD_FAILURE'
export const CLEAR_UPLOADS = 'CLEAR_UPLOADS'

export const uploadRequest = (key: string, objectId: string, url: string, file: any) => ({
  type: UPLOAD_REQUEST,
  key,
  objectId,
  url,
  file,
})

export const uploadProgress = (key: string, progress: number) => ({
  type: UPLOAD_PROGRESS,
  key,
  progress,
})

export const uploadSuccess = (key: string) => ({
  type: UPLOAD_SUCCESS,
  key,
})

export const uploadFailure = (key: string, error: Error) => ({
  type: UPLOAD_FAILURE,
  key,
  error,
})

export const clearUploads = (keys: Array<string>) => ({
  type: CLEAR_UPLOADS,
  keys,
})
